import * as React from "react";

;
export const MobilePhone = (props: React.SVGProps<SVGSVGElement>) => <svg width={24} height={24} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M18.9.25H5.25v23.5H18.9V.25zM6.75 18.286V1.75H17.4v16.536H6.75zm6.583 2.095a1.048 1.048 0 11-2.095 0 1.048 1.048 0 012.095 0z" fill="#100722" /></svg>;